import { IAuthUser } from 'authOld/types';
import { DropdownNav, NavItem } from 'coreOld/components';
import { Icon } from 'coreOld/elements';
// eslint-disable-next-line no-restricted-imports
import { DropdownOptions, INavItem } from 'coreOld/types';

import {
  navBrowseStructure,
  navCompanyStructure,
  navPricingProfileStructure,
  navStructure,
} from './navStructure';
import { NavWrapper } from './rightNavigationStyle';

interface IProps {
  user?: IAuthUser;
  openedDropdown: DropdownOptions;
  toggleDropdown: (name: string) => void;
}

const RightNavigationView = ({ user, openedDropdown, toggleDropdown }: IProps) => {
  return (
    <NavWrapper>
      <DropdownNav
        navItems={navBrowseStructure()}
        name="Browse"
        isOpen={openedDropdown.browse}
        toggleDropdown={() => toggleDropdown('browse')}
        style={{ borderRight: '1px solid #fff' }}
        userResources={user?.resources}
      />

      {navStructure()?.map((item: INavItem, idx) => (
        <NavItem
          key={`${idx}-${item?.name}`}
          url={item?.url}
          matchedPath={item?.matchedPath}
          onClick={item?.onClick}
          icon={item.icon}
          secondaryNav
        />
      ))}

      <DropdownNav
        navItems={navPricingProfileStructure()}
        icon={<Icon name={Icon.USD} />}
        secondaryNav
        isOpen={openedDropdown.pricing}
        toggleDropdown={() => toggleDropdown('pricing')}
        userResources={user?.resources}
      />

      <DropdownNav
        navItems={navCompanyStructure()}
        icon={<Icon name={Icon.COMPANY} />}
        secondaryNav
        isOpen={openedDropdown.company}
        toggleDropdown={() => toggleDropdown('company')}
        userResources={user?.resources}
      />
    </NavWrapper>
  );
};

export default RightNavigationView;
